// @flow
import { connect } from 'react-redux';
import IndexGrabSuccess from './IndexGrabSuccess';
import { getProfileInformation } from '../../../modules/home';

const mapStateToProps = (state) => ({
  profileInformation: getProfileInformation(state),
});
export default connect(mapStateToProps, null)(IndexGrabSuccess);
